import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { DownloadFolderFileBySharingLinkRequest, DownloadFolderFileBySharingLinkResponse } from "@maven-rest/docs/FolderSharingLink.dto";
import { FolderSharingLinkUrl } from "@maven-rest/docs/FolderSharingLink.url";

export function useDownloadFolderFileBySharingLinkMutation(
  pathVariable: Pick<DownloadFolderFileBySharingLinkRequest, "fileId">,
  options?: SimpleMutationOptions<DownloadFolderFileBySharingLinkResponse, DownloadFolderFileBySharingLinkRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderSharingLinkUrl.downloadFolderFileBySharingLink(pathVariable.fileId),
    },
    ...options,
  });
}
